import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    addPricePackagesClientsModal,
    closePricePackagesClientsModal,
    deletePricePackagesClientsModal,
    savePricePackagesClientsModal
} from '../../actions/pricePackagesClientsModal';
import { PricePackagesClientsModal } from '../../components/PricePackagesClientsModal/PricePackagesClientsModal';
import { PricePackagesClientsModalProps } from '../../components/PricePackagesClientsModal/PricePackagesClientsModal';
import { State } from '../../typings/state';
import { TargetingTagValue } from '../../typings/tagCloudTargeting';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<PricePackagesClientsModalProps>;

type DispatchProps = TDispatchProps<PricePackagesClientsModalProps>;

const mapStateToProps = (state: State): StateProps => {
    const { isVisible, tags, title, errors, isProgress } = state.pricePackagesClientsModal;

    return {
        isVisible,
        tags,
        title,
        errors,
        isProgress
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onClose: () => {
            dispatch(closePricePackagesClientsModal());
        },
        onAdd: (tags: TargetingTagValue[]) => {
            dispatch(addPricePackagesClientsModal(tags));
        },
        onDelete: (tag: TargetingTagValue) => {
            dispatch(deletePricePackagesClientsModal(tag));
        },
        onSave: () => {
            dispatch(savePricePackagesClientsModal());
        }
    };
};

export const PricePackagesClientsModalContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(PricePackagesClientsModal);
